// extracted by mini-css-extract-plugin
export default {"card":"Sources_card__i-ot-","title":"Sources_title__BqA+g","copy_btn":"Sources_copy_btn__XUtAH","validationMessage":"Sources_validationMessage__7rqB4"};